import clsx from 'clsx'
import { useContext, useEffect, useState } from 'react'
import { FiMenu } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useLayout } from '../../core'
// import {Header} from './Header'
import { DefaultTitle } from './page-title/DefaultTitle'
import { Topbar } from './Topbar'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { imageBaseUrl } from 'src/cms/helpers/constants'
import { Header } from 'antd/es/layout/layout'
import { Button, Divider } from 'antd'
import { FaBars } from 'react-icons/fa'
import { ActiveMenuContex } from '../../MasterLayout'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { header, aside } = config
  const [logo, setLogo] = useState('')
  const activeMenu: any = useContext(ActiveMenuContex)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const authResp = useSelector((state: any) => state.auth)
  const { user } = authResp

  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  const showDrawer = () => {
    activeMenu.setOpen(true)
  }
  return (
    <>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 9,
          boxShadow: 'rgba(122, 122, 122, 0.12) 0px 0.4rem 0.7rem',
          background: '#e6f5ff'
        }}
        className='d-flex align-items-center justify-content-between'
      >
        <div className='d-flex align-items-center'>
          <Button
            type='primary'
            size='large'
            icon={<FaBars />}
            style={{ marginRight: '1rem' }}
            onClick={showDrawer}
          />
          <Link to='/dashboard'>
            <img
              alt='Logo'
              className=' logo'
              height={45}
              // src='/media/logos/global-ime-logo-svg.jpg'
              src={`${imageBaseUrl}/${logo}` || `/media/logos/global-ime-logo-svg.jpg`}
            />
          </Link>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <h4 className='fw-bolder m-0 p-0 pt-1' style={{ color: '#043F86' }}>  {user?.data?.branches?.some((branch: any) => branch?.title === 'ALL') ? 'ALL BRANCHES' : user?.data?.branches?.length > 0 ? `${user?.data?.branches?.[0]?.title}, + ${user?.data?.branches?.length - 1} Branches` : 'ALL'}</h4>
          <Divider type='vertical' style={{ height: '4em' }} />
          <Topbar />
        </div>
      </Header>
    </>
  )
}
